<template>
  <div
    class="modal fade"
    id="generate-promotion-certificate"
    tabindex="-1"
    role="dialog"
    aria-labelledby="generate-promotion-certificate-label"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header row mx-0 py-1">
          <div class="col col-sm-8">
            <h6
              class="modal-title font-weight-bolder"
              id="generate-promotion-certificate-label"
            >
              GENERATE {{ promotionTraining.courseName }}
            </h6>
          </div>
          <div class="col col-sm-4">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-sm btn-outline-secondary font-weight-bolder ml-2 float-right"
            >
              Close
            </button>
          </div>
        </div>

        <div class="modal-body p-0">
          <form @submit.prevent="confirmGeneratePromotionCertificate">
            <div class="form-group form-row mt-2">
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right pl-0"
                for="certificate-number"
              >Certificate Number:</label>
              <div class="col col-sm-5">
                <input
                  type="text"
                  id="certificate-number"
                  class="form-control form-control-xs form-control-xxs"
                  placeholder="Certificate Number"
                  v-model="promotionTraining.certificateNumber"
                >
              </div>
              <div class="col col-sm-3">
                <button
                  type="submit"
                  class="btn btn-sm btn-xs btn-warning font-weight-bolder my-auto"
                >
                  <span class="fas fa-edit" />
                  Update
                </button>
              </div>
            </div>

            <div class="form-group form-row mt-2">
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right pl-0"
                for="promotion-date"
              >Promotion Date:</label>
              <div class="col col-sm-5">
                <input
                  type="date"
                  id="promotion-date"
                  class="form-control form-control-xs form-control-xxs"
                  required
                  v-model="promotionTraining.promotionDate"
                >
              </div>
            </div>

            <div class="form-group form-row mt-2">
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right pl-0"
                for="certificate-number"
              >Promotion Rank:</label>
              <div class="col col-sm-5">
                <!--                <input type="date" id="certificate-number" class="form-control form-control-xs form-control-xxs" required-->
                <!--                >-->

                <select
                  class="form-control form-control-xs select-center"
                  required
                  v-model="promotionTraining.rankId"
                >
                  <option :value="undefined">
                    --- Select Rank ---
                  </option>
                  <option
                    v-for="rankKey in rankKeys"
                    :key="rankKey.id"
                    :value="rankKey.id"
                  >
                    {{ rankKey.name }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formMixins } from '@/mixins/formMixins';

export default {
  name: "GeneratePromotionCertificate",

  mixins: [ formMixins ],

  props: {
    promotionTraining: {
      type: Object,
      default() {
        return {};
      }
    },
  },

  methods: {
    ...mapActions([
        'generatePromotionCertificate',
        'getRankKeys'
    ]),

    async confirmGeneratePromotionCertificate() {
      if (await this.confirmCreateAlert()) {
        let params = {
          trainingCourseId: this.promotionTraining.trainingCourseId,
          crewId: this.crew.detail.id,
          rankId: this.promotionTraining.rankId,
          date: this.promotionTraining.promotionDate,
          certificateNumber: this.promotionTraining.certificateNumber,
        }
        let updatedCrewTraining = await this.generatePromotionCertificate(params);
        if(updatedCrewTraining) {
          if(updatedCrewTraining.errors) {
            this.errorAlert('Failed to Generate Promotion Certificate', 'GENERATE')
          } else {
            this.successAlert('Promotion Certificate Successfully Generated', 'GENERATE')
          }
        } else {
          this.errorAlert('Failed to Generate Promotion Certificate', 'GENERATE')
        }
      }
    }
  },

  computed: {
    ...mapGetters([
        'rankKeys',
        'crew'
    ])
  },

  created() {
    this.getRankKeys();
  }


}
</script>

<style scoped>

</style>